module.exports = __webpack_public_path__ + "img/MaskGroup(2).725b54e1.png";